import React from 'react'
import { Box, Card, CardContent, Typography } from '@material-ui/core'
import { format } from 'date-fns'

export default function Comments({ comments }) {
  return (
    <Box>
      {comments &&
        comments
          .slice()
          .reverse()
          .map((comment) => (
            <Box mt={2}>
              <Card>
                <CardContent>
                  <Typography component="h5" variant="h5">
                    {comment.comment}
                  </Typography>
                  <Typography>
                    {format(comment.createdAt, 'dd.MM.yyyy')}
                  </Typography>
                  <Typography style={{ fontWeight: 'bold' }}>
                    {comment.commentedBy}
                  </Typography>
                  <small>{comment.userType}</small>
                </CardContent>
              </Card>
            </Box>
          ))}
    </Box>
  )
}
